import script from "./RegisterUser.vue?vue&type=script&setup=true&lang=js"
export * from "./RegisterUser.vue?vue&type=script&setup=true&lang=js"

import "./RegisterUser.vue?vue&type=style&index=0&id=08dff1a6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08dff1a6"]])

export default __exports__